import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useToggleTheme = () => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const lightImage = `url('${imageBaseUrl}/common/light-overviewBg.png')`;
    const darkImage = `url('${imageBaseUrl}/common/overviewBg.png')`;

    // Initialize theme based on localStorage or system preference
    const [darkMode, setDarkMode] = useState(() => {
        // Check localStorage first
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            return savedTheme === 'dark';
        }

        // Fall back to system preference
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
            document.documentElement.style.setProperty('--overviewImage', darkImage);
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
            document.documentElement.style.setProperty('--overviewImage', lightImage);
        }
    }, [darkMode]);

    return [darkMode, setDarkMode];
};

export default useToggleTheme;
